import React, { Component } from 'react';
import propTypes from 'prop-types';
import { mapStackTrace } from 'sourcemapped-stacktrace';
import { errorApi } from '~/Providers/Api';

import './Quote.scss';

class Quote extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fontSize: 1,
    };
  }

  render() {
    const { quote, showHeader, showFooter } = this.props;
    if (!quote) return <div className="quote" />;

    return (
      <div className="quote">
        {showHeader && (
          <div className="top-spacing">
            <hr />
            <hr />
          </div>
        )}
        <div
          className="quote-text"
          ref={r => (this.quoteText = r)}
          style={{ fontSize: `${this.state.fontSize}em` }}
        >{`"${quote.quote}"`}</div>
        <div className="author"> - {quote.author}</div>
        {showFooter && (
          <div className="bottom-spacing">
            <hr />
            <hr />
          </div>
        )}
      </div>
    );
  }
}

Quote.propTypes = {
  quote: propTypes.oneOfType([propTypes.object, propTypes.bool]),
  showHeader: propTypes.bool,
  showFooter: propTypes.bool,
};

Quote.defaultProps = {
  showHeader: true,
  showFooter: true,
};

export default Quote;
